import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlPrefix } from "../constants/url-prefix.constants";

@Injectable()
export class BlockedUsersService {

  constructor(private http: HttpClient) { }

  public getBlockedUsers(): Observable<Array<number>> {
    return this.http.get<Array<number>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/users/blockedUsers`);
  }
}
